import React from 'react';

import { Icon } from '@iconify/react';
import { TFunction } from 'i18next';

import { getSubscriptionTitle } from '~/modules/settings/getSubscriptionTitle';
import projectConfig, { PROJECT } from '~/projects/config';
import { getComplianceProfile } from '~/services/compliance';

type SettingsConfig = {
  getPersonalInformationTitle: (t: TFunction) => string;
  getPersonalInformationIcon: (props: {
    isActive?: boolean | undefined;
  }) => JSX.Element;
  getSecurityTitle: (t: TFunction) => string;
  getSecurityIcon: (props: { isActive?: boolean | undefined }) => JSX.Element;
  getSubscriptionTitle: (t: TFunction) => string;
  getSubscriptionIcon: (props: {
    isActive?: boolean | undefined;
  }) => JSX.Element;
  getBillingHistoryTitle: (t: TFunction) => string;
  getBillingHistoryIcon: (props: {
    isActive?: boolean | undefined;
  }) => JSX.Element;
};

const settingsConfigByProject: Readonly<Record<PROJECT, SettingsConfig>> = {
  [PROJECT.POLYLLM_CHAT]: {
    getPersonalInformationTitle: (t: TFunction): string =>
      t('general:personal_information', 'Personal Information'),
    getPersonalInformationIcon: (props) => (
      <Icon {...props} icon="material-symbols:person-outline" />
    ),
    getSecurityTitle: (t: TFunction): string =>
      t('general:password', 'Password'),
    getSecurityIcon: (props) => (
      <Icon {...props} icon="material-symbols:key-outline" />
    ),
    getSubscriptionTitle: (t: TFunction): string =>
      getSubscriptionTitle(t, getComplianceProfile()),
    getSubscriptionIcon: (props) => (
      <Icon {...props} icon="material-symbols:card-membership-outline" />
    ),
    getBillingHistoryTitle: (t: TFunction): string =>
      t('general:billing_history', 'Billing History'),
    getBillingHistoryIcon: (props) => (
      <Icon {...props} icon="material-symbols:receipt-long-outline" />
    ),
  },
};

const getConfigByProject = (): SettingsConfig => {
  return settingsConfigByProject[projectConfig.project];
};

export const SETTINGS_PROJECT_CONFIG = getConfigByProject();
